export { default } from './AvisUHDHDR';
